import { FC } from 'react';
import { ButtonElement } from '../Button';
import { Text } from '../Text';
import { TextCombination } from '../TextCombination';
import { SelfServeLinks } from './SelfServeLinks';

type QualifiedSchedulerStepProps = {
  reOpenQualifiedScheduler: () => void;
  onClose?: () => void;
}

const QualifiedSchedulerStep: FC<QualifiedSchedulerStepProps> = ({
  reOpenQualifiedScheduler,
  onClose,
}) => {

  return (
    <div className="flex flex-col gap-lg">
      <TextCombination
        type="h3p2"
        align="left"
        title="We look forward to connecting"
        description="A scheduler will open momentarily, or you can click the button below to find a time to chat."
      />
      <ButtonElement
        variant="primary"
        buttonType="filled"
        text="Schedule a demo"
        onClick={() => {
          reOpenQualifiedScheduler();
        }}
      />
      <Text type="p2" >There are also some ways to explore Front on your own.</Text>
      <SelfServeLinks onClose={onClose} />
    </div>
  );
};

export default QualifiedSchedulerStep;
